import {isInViewport} from "../../default/global/js/utilities/viewport";

function resetSpacerMobile(target) {
    for (let item of target.querySelectorAll('.cms_textcontent')) {
        item.style.width = "";
    }
    target.style.height = "";
}

function generateSpacerMobile(target, text) {
    resetSpacerMobile(target);
    text.style.width = window.outerWidth + "px";
    let textHeight = text.offsetHeight;
    let targetHeight = target.offsetHeight;
    target.style.height = (targetHeight + textHeight) + "px";
}

function showInteractiveCursorText(target, count) {
    target.setAttribute('data-current-count', count);
    let active = false;
    for (let item of target.querySelectorAll('.interactiveCursor__text')) {
        if (item.hasAttribute('data-count')) {
            if (parseInt(item.dataset.count) === parseInt(count)) {
                item.classList.add('active');
                item.parentNode.classList.add('active');
                if (item.closest('.interactiveCursor__text') && window.outerWidth < 768) {
                    generateSpacerMobile(target, item);
                }
                active = true;
            } else {
                item.classList.remove('active');
                item.parentNode.classList.remove('active');
            }
        } else {
            item.classList.remove('active');
            item.parentNode.classList.remove('active');
        }
    }

    if (active) {
        target.classList.add('active');
    } else {
        target.classList.remove('active');
    }
}

function setInteractiveDescriptionActive(target) {
    const count = target.dataset.currentCount;
    for (let item of target.querySelectorAll('.interactiveCursor__description')) {
        if (item.hasAttribute('data-count')) {
            if (parseInt(item.dataset.count) === parseInt(count)) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        } else {
            item.classList.remove('active');
        }
    }
}

function checkInteractiveCursorAnimation(target) {
    if (target) {
        let animationInt;
        const tolerance = 10;
        let positionsOfPoints = [];
        let interactiveCursorPoints = target.querySelectorAll('.interactiveCursor__description');
        let activePoint = target.querySelector('.activePoint');
        let currentCount = 0;

        function getPositionOfPoints() {
            let pointWrapperPosition = target.getBoundingClientRect();
            let positionsOfPoints = [];
            for (let item of target.querySelectorAll('.interactiveCursor__descPoint')) {
                let pointPosition = item.getBoundingClientRect();
                positionsOfPoints.push({
                    item: item.parentNode,
                    x: pointPosition.x - pointWrapperPosition.x,
                    y: pointPosition.y - pointWrapperPosition.y,
                    width: pointPosition.width,
                    height: pointPosition.height
                });
            }
            return positionsOfPoints;
        }

        function getPositionOfActivePoint() {
            let activePointWrapperPosition = activePoint.closest('.interactiveCursor').getBoundingClientRect();
            let activePointPosition = activePoint.getBoundingClientRect();
            let x = activePointPosition.x - activePointWrapperPosition.x;
            let y = activePointPosition.y - activePointWrapperPosition.y;

            return {
                xCenter: x + parseInt(activePointPosition.width / 2),
                yCenter: y + parseInt(activePointPosition.height / 2),
                width: activePointPosition.width,
                height: activePointPosition.height,
            };
        }

        function checkActivePointOver(positionItem, activePointPosition) {
            let isX = false;
            let isY = false;
            if (activePointPosition.xCenter > (positionItem.x - tolerance) && activePointPosition.xCenter < (positionItem.x + positionItem.width + tolerance)) {
                isX = true;
            }
            if (activePointPosition.yCenter > (positionItem.y - tolerance) && activePointPosition.yCenter < (positionItem.y + positionItem.height + tolerance)) {
                isY = true;
            }
            if (isX && isY) {
                return true;
            }
            return false;
        }

        function startInteractiveCursorAnimation() {
            if (interactiveCursorPoints) {
                if (!target.classList.contains('isrunning')) {
                    target.classList.add('isrunning');
                    target.querySelector('.activePointWrapper').style.animation = "";
                    positionsOfPoints = getPositionOfPoints();
                    animationInt = setInterval(function () {
                        let activePointPosition = getPositionOfActivePoint();
                        for (let positionItem of positionsOfPoints) {
                            if (checkActivePointOver(positionItem, activePointPosition)) {
                                currentCount = positionItem.item.dataset.count;
                                showInteractiveCursorText(target, currentCount);
                                setInteractiveDescriptionActive(target);
                            }
                        }

                    }, 100);
                }
            }
        }

        function stopInteractiveCursorAnimation() {
            clearInterval(animationInt);
            target.classList.remove('isrunning');
        }

        function resetInteractiveCursorAnimation() {
            showInteractiveCursorText(target, "-1");
            setInteractiveDescriptionActive(target);
            resetSpacerMobile(target);
            target.querySelector('.activePointWrapper').style.animation = "none";
        }

        target.addEventListener('mouseover', function () {
            if (isInViewport(target)) {
                stopInteractiveCursorAnimation();
            }
        })

        target.addEventListener('mouseleave', function () {
            if (isInViewport(target)) {
                startInteractiveCursorAnimation();
            }
        });

        window.addEventListener("scroll", function () {
            if (isInViewport(target)) {
                startInteractiveCursorAnimation();
            } else {
                resetInteractiveCursorAnimation();
                stopInteractiveCursorAnimation();
            }
        });
    }
}

export function initInteractiveCursor() {
    const interactiveCursors = document.querySelectorAll('.interactiveCursor');
    if(interactiveCursors){
        for (const interativeCursor of interactiveCursors) {
            const interativeCursorWrapper = interativeCursor.querySelector('.interactiveCursor__wrapper');
            let activePointWrapper = document.createElement('div');
            activePointWrapper.classList.add('activePointWrapper');
            activePointWrapper.innerHTML = "<div class='activePoint'></div>";
            interativeCursorWrapper.appendChild(activePointWrapper);

            let count = 0;
            for (let description of interativeCursor.querySelectorAll('.interactiveCursor__description')) {
                let text = description.innerText;
                description.innerHTML = "<i class='interactiveCursor__descPoint'></i>" + text;
                description.setAttribute('data-count', count);
                count++;
                description.addEventListener('click', function () {
                    showInteractiveCursorText(interativeCursor, description.dataset.count);
                    setInteractiveDescriptionActive(interativeCursor);
                });
            }
            count = 0;
            for (let text of interativeCursor.querySelectorAll('.interactiveCursor__text')) {
                text.setAttribute('data-count', count);
                count++;
            }

            checkInteractiveCursorAnimation(interativeCursor);
        }
    }
}